import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import RTTable from "../../../components/Comman/RT/RTTable";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import endpoint from "../../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import { LeaveAnalysisJson } from "../../../DynamicFormsJson/MastersJSON/LeaveAnalysis";
import { getLeaveSummaryBySalesTeam } from "../../../Slice/LeaveType.slice";
import { getSalesExecutiveByUserType } from "../../../Slice/salesExecutive.slice";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { downloadF } from "../../PDF/PDFDownload";
import LeaveAnalysisPopUp from "./LeaveAnalysisPopUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MyComponentWithIconProps } from "../../../components/Comman/IconButton";
import { imageUrl } from "../../../config/Url";

class LeaveAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
      },
      viewPopup: false,
      viewData: {},
      DataToSet: [],
      fixedCalculation: "",
      formData: { type: "0" },
      leaveApplyDetails: [],
      searchValue: "",
      dataToSend: {},
      salesTeamId: "",
      fromDate: "",
      toDate: "",
    };
  }

  componentDidMount() {
    const { getSalesExecutiveByUserType, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
        ({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.salesPersonList !== nextProps.salesPersonList) {
      if (
        this.props.salesPersonList?.salesPersonByArea !==
        nextProps.salesPersonList?.salesPersonByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
          },
        });
      }
    }
  }

  onSearch = (data) => {
    const { getLeaveSummaryBySalesTeam, showLoador, showNotification } =
      this.props;
    this.setState({
      salesTeamId: data?.salesTeamIds,
      fromDate: data?.fromDate,
      toDate: data?.toDate,
    });

    if (navigator.onLine) {
      showLoador({ loador: true });
      getLeaveSummaryBySalesTeam({
        salesTeamId: data?.salesTeamIds,
        fromDate: data?.fromDate,
        toDate: data?.toDate,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else if (!response || response.length === 0) {
          showNotification({ msg: "Data Not Found", severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  onClickViewPreview = (rowData) => {
    if (rowData?.attachFile && rowData.attachFile.trim() !== "") {
      window.open(imageUrl + rowData.attachFile, "_blank");
    } else {
      showNotification({ msg: "No Attachment Found", severity: "error" });
    }
  };

  rowView = (rowData) => {
    const { showLoador, showNotification } = this.props;
    let viewDataList = [];
    let leaveApplyDetails = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.leaveAndClaimLog +
        "/by-leave-or-claim-id?leaveOrClaimId=" +
        rowData.id,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      let dataToSend = {
        attachFile: rowData.attachFile ? rowData.attachFile : "",
      };
      if (success) {
        leaveApplyDetails = data.data.map((dataObj, index) => {
          let datePart = "";
          let timePart = "";
          if (dataObj.insertDateTime) {
            const [date, time] = dataObj.insertDateTime.split(" ");
            datePart = date;
            timePart = time;
          }
          let dataJson = {
            index: index + 1,
            authorityName:
              dataObj.authorityName !== null ? dataObj.authorityName : "",

            operationType:
              dataObj.operationType === null
                ? ""
                : dataObj.operationType == 0
                  ? "Applied"
                  : dataObj.operationType == 1
                    ? "Approved"
                    : "Cancelled",

            insertDate: datePart || "",
            insertTime: timePart || "",

            insertedUserName:
              dataObj.insertedUserName !== null ? dataObj.insertedUserName : "",
          };
          return dataJson;
        });
        viewDataList.push(data.data);

        const detail = data.data.find((d) => d.entityId === rowData.id);

        this.setState({
          DataToSet: [
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Date",
              value: detail?.date || "-",
            },
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Sales Team",
              value: detail?.salesTeamName || "-",
            },

            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Subject",
              value: rowData?.leaveReason || "-",
            },

            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "No of Days",
              value: rowData?.noOfDays || "-",
            },
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Days",
              value: rowData?.days || "-",
            },
            {
              xs: 12,
              sm: 2.8,
              md: 2.8,
              lg: 2.8,
              label: "Attach File",
              value: rowData?.attachFile ? (
                <MyComponentWithIconProps
                  statusImage={VisibilityIcon}
                  color="primary"
                  fontSize="medium"
                  title="View"
                  onClick={() => this.onClickViewPreview(dataToSend)}
                  sx={{ marginLeft: "70px" }}
                />
              ) : (
                <span style={{ marginLeft: "70px", color: "gray" }}>-</span>
              )
            },
            {
              md: 12,
              lg: 12,
              sm: 12,
              xs: 12,
              labelSM: 1.3,
              labelMD: 1.3,
              labelLG: 1.3,
              valueSM: 10,
              valueMD: 10,
              valueLG: 10,
              label: "Description",
              value: rowData?.description || "-",
            },
          ],
          leaveApplyDetails: leaveApplyDetails,
          viewData: viewDataList,
          viewPopup: true,
          dataToSend: dataToSend,
        });
      }
    });
  };
  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  getFilteredTableData = (leaveList) => {
    const { searchValue } = this.state;
    return leaveList.filter((currentRow) => {
      let isValid = false;
      let employeeCode =
        currentRow.employeeCode != null ? currentRow.employeeCode : "-";
      let name = currentRow.name != null ? currentRow.name : "-";
      let authoritySalesPersonName =
        currentRow.authoritySalesPersonName != null
          ? currentRow.authoritySalesPersonName
          : "-";
      let fromDate = currentRow.fromDate != null ? currentRow.fromDate : "-";
      let toDate = currentRow.toDate != null ? currentRow.toDate : "-";
      let noOfDays = currentRow.noOfDays != null ? currentRow.noOfDays : "-";
      let leaveTypeName =
        currentRow.leaveTypeName != null ? currentRow.leaveTypeName : "-";
      let leaveReason =
        currentRow.leaveReason != null ? currentRow.leaveReason : "-";
      let description =
        currentRow.description != null ? currentRow.description : "-";
      let days = currentRow.days != null ? currentRow.days : "-";
      let status = currentRow.status != null ? currentRow.status : "-";
      if (
        employeeCode &&
        employeeCode
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        name &&
        name.toLowerCase().toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        authoritySalesPersonName &&
        authoritySalesPersonName
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        fromDate &&
        fromDate.toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        toDate &&
        toDate.toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        noOfDays &&
        noOfDays.toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        leaveTypeName &&
        leaveTypeName
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        leaveReason &&
        leaveReason
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        description &&
        description
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (days && days.toString().includes(searchValue.trim().toLowerCase())) {
        isValid = true;
        return true;
      }
      if (
        status &&
        status
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }

      return isValid;
    });
  };

  onSearchInTable = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  generateExcel = () => {
    const { fromDate, toDate, salesTeamId } = this.state;
    const { showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: true,
        url:
          endpoint.exportData +
          "/leave-apply-list-by-sales-team-and-date-excel?fromDate=" +
          fromDate +
          "&toDate=" +
          toDate +
          "&salesTeamId=" +
          salesTeamId,
        ext: "xls",
        openNewTab: false,
      }).then((response) => {
        if (!response) {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { leaveList } = this.props;
    const {
      dynamicMasterData,
      salesPersonList,
      viewPopup,
      leaveApplyDetails,
      viewData,
      DataToSet,
      fixedCalculation,
      formData,
      dataToSend,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            callBeforeSave={true}
            callBeforeSaveMethod={this.callBeforeSaveMethod}
            formPath={LeaveAnalysisJson.formPath}
            showPdfDownload={false}
            showExcelDownload={false}
            showBackToList={false}
            dynamicMasterData={dynamicMasterData}
            getListById={this.getListById}
            screenTitle={LeaveAnalysisJson.screenTitle}
            fieldMeta={LeaveAnalysisJson.fieldMeta}
            apiBaseURL={LeaveAnalysisJson.apiBaseURL}
            showSaveNextBtn={LeaveAnalysisJson.showSaveNextBtn}
            isEditURL={LeaveAnalysisJson.isEditURL}
            showSaveBtnMain={false}
            showSaveBtn={true}
            onSave={this.onSearch}
            saveBtnText={"Search"}
            showCancel={false}
          />

          {leaveList?.leaveSummaryBySalesTeam?.length > 0 && (
            <LandingScreenHeader
              screenTitle={""}
              showSearchBox={true}
              showTable={true}
              showFilter={false}
              showPdfDownload={false}
              showExcelDownload={true}
              generateExcel={this.generateExcel}
              onSearch={this.onSearchInTable}
            />
          )}

          {leaveList?.leaveSummaryBySalesTeam?.length > 0 && (
            <RTTable
              showPegination={false}
              columns={[
                { name: "index", title: "Sr. No.", align: "center" },
                {
                  name: "employeeCode",
                  title: "Employee Code",
                  align: "center",
                },
                {
                  name: "name", title: "Leave From", align: "Left",
                },
                {
                  name: "authoritySalesPersonName",
                  title: "Leave To",
                  align: "Left",
                },
                { name: "fromDate", title: "From Date", align: "center" },
                { name: "toDate", title: "To Date", align: "center" },
                { name: "noOfDays", title: "No Of Days", align: "center" },
                { name: "days", title: "Days", align: "left" },
                {
                  name: "leaveTypeName",
                  title: "Leave Type",
                  align: "left",
                },
                { name: "leaveReason", title: "Leave Reason", align: "left" },

                { name: "status", title: "Status", align: "left" },
                { name: "total", title: "Action", align: "right" },
              ]}
              tableData={this.getFilteredTableData(
                leaveList?.leaveSummaryBySalesTeam
              )}
              isActionColActive={true}
              showEditIcon={false}
              showDeleteIcon={false}
              showViewButtonInTable={true}
              rowView={this.rowView}
            />
          )}
        </Paper>
        {viewPopup && (
          <LeaveAnalysisPopUp
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            columns={[
              {
                title: "Sr. No.",
                name: "index",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
              {
                title: "Authority Name",
                name: "authorityName",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
              {
                title: "Leave Status",
                name: "operationType",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
              {
                title: "Date",
                name: "insertDate",
                positionCenter: true,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
              {
                title: "Time",
                name: "insertTime",
                positionCenter: true,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
              {
                title: "By",
                name: "insertedUserName",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                align: "center",
                canSearch: true,
              },
            ]}
            rows={leaveApplyDetails}
            viewHeaderData={viewData}
            DataToSet={DataToSet}
            dataToSend={dataToSend}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
  leaveList: state.leaveType,
});
const mapDispatchToProps = {
  getSalesExecutiveByUserType,
  getLeaveSummaryBySalesTeam,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(LeaveAnalysis);
